export default "__VITE_ASSET__BuSU7Twg__"